export {
  default
} from 'diagram-js/lib/command';

